import { useState, useEffect } from 'react'
import {
  getDeltas,
  getEventos,
  getAlertas,
  getMyRol,
  getDocumentEstadistica,
  postLogTom,
  getEventosByRol,
  postBitacora,
  postMultipleBitacora,
} from '@auteco/services/tomService'
import * as XLSX from 'xlsx'

export const useTomDashboard = () => {
  // Estados compartidos
  const [deltas, setDeltas] = useState([])
  const [eventos, setEventos] = useState([])
  const [alertas, setAlertas] = useState([])
  const [myRol, setMyRol] = useState(null)
  
  // Estados de carga
  const [isLoadingDeltas, setIsLoadingDeltas] = useState(true)
  const [isLoadingAlertas, setIsLoadingAlertas] = useState(true)
  const [isLoadingEventos, setIsLoadingEventos] = useState(true)
  const [isLoadingDocumento, setIsLoadingDocumento] = useState(false)
  const [isLoadingGestion, setIsLoadingGestion] = useState(false)
  const [loadingRow, setLoadingRow] = useState(null)
  const [loadingRows, setLoadingRows] = useState([])
  
  // Estados del dashboard
  const [procesoFiltro, setProcesoFiltro] = useState('disponibilidad')
  const [mostrarGestionados, setMostrarGestionados] = useState(false)
  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [mostrarAlertas, setMostrarAlertas] = useState(false)
  
  // Estados de gestión
  const [eventosGestion, setEventosGestion] = useState([])
  const [gestionDataLoaded, setGestionDataLoaded] = useState(false)
  
  // Estado del tab activo
  const [activeTab, setActiveTab] = useState(0)
  
  // Estados para MaterialReactTable
  const [rowSelection, setRowSelection] = useState({})

  // Funciones de obtención de datos
  const handleGetMyRol = async () => {
    const response = await getMyRol()
    setMyRol(response.iam)
  }

  const handleGetDeltas = async () => {
    setIsLoadingDeltas(true)
    try {
      const response = await getDeltas()
      setDeltas(response.deltas)
    } catch (error) {
      console.error('Error loading deltas:', error)
    } finally {
      setIsLoadingDeltas(false)
    }
  }

  const handleGetAlertas = async () => {
    setIsLoadingAlertas(true)
    try {
      const response = await getAlertas()
      setAlertas(response.alertas)
    } catch (error) {
      console.error('Error loading alertas:', error)
    } finally {
      setIsLoadingAlertas(false)
    }
  }

  const handleGetEventos = async () => {
    setIsLoadingEventos(true)
    try {
      const response = await getEventos()
      console.log(response.eventos)
      setEventos(response.eventos)
    } catch (error) {
      console.error('Error loading eventos:', error)
    } finally {
      setIsLoadingEventos(false)
    }
  }

  // Función para cargar datos del dashboard
  const getInfo = async () => {
    await postLogTom({
      action: 'Entra dashboard',
    })
    await Promise.all([
      handleGetDeltas(),
      handleGetEventos(),
      handleGetAlertas()
    ])
    console.log('Actualizando información')
  }

  // Función para cargar datos de gestión
  const loadGestionData = async () => {
    if (myRol && !gestionDataLoaded && !isLoadingGestion) {
      setIsLoadingGestion(true)
      try {
        await postLogTom({
          action: 'Entra gestion ',
        })
        const response = await getEventosByRol(myRol.id)
        console.log(response, 'Eventos')
        setEventosGestion(response.eventos)
        setGestionDataLoaded(true)
      } catch (error) {
        console.error('Error loading gestion data:', error)
      } finally {
        setIsLoadingGestion(false)
      }
    }
  }

  // Función para refrescar datos del dashboard
  const refreshDashboardData = async () => {
    if (!isLoadingDeltas && !isLoadingEventos && !isLoadingAlertas) {
      await postLogTom({
        action: 'Refresca dashboard',
      })
      await Promise.all([
        handleGetDeltas(),
        handleGetEventos(),
        handleGetAlertas()
      ])
    }
  }

  // Función para refrescar datos de gestión
  const refreshGestionData = async () => {
    if (myRol && !isLoadingGestion) {
      setIsLoadingGestion(true)
      try {
        const response = await getEventosByRol(myRol.id)
        setEventosGestion(response.eventos)
        setGestionDataLoaded(true)
      } catch (error) {
        console.error('Error refreshing gestion data:', error)
      } finally {
        setIsLoadingGestion(false)
      }
    }
  }

  // Función para descargar Excel
  const downloadExcel = async () => {
    await postLogTom({
      action: 'Descarga Excel',
    })
    const responseRol = await getMyRol()
    const { id } = responseRol.iam
    setIsLoadingDocumento(true)
    const response = await getDocumentEstadistica(id)
    const worksheet = XLSX.utils.json_to_sheet(response.eventos)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Eventos')
    XLSX.writeFile(workbook, 'eventos.xlsx')
    setIsLoadingDocumento(false)
  }

  // Función para manejar filtro de proceso
  const handleProcesoFiltro = async (proceso) => {
    setProcesoFiltro(proceso);
  
    await new Promise(resolve => setTimeout(resolve, 1500));
  
    await postLogTom({
      action: `Filtra por proceso ${proceso}`,
    });
  };

  // Funciones de gestión
  const handlePostBitacora = async (body) => {
    setIsLoadingGestion(true)
    const response = await postBitacora(body)
    if (response) {
      console.log(response, 'Bitacora creada')
    }
    const newResponse = await getEventosByRol(myRol.id)
    setEventosGestion(newResponse.eventos)
    setIsLoadingGestion(false)
  }

  const handleEstadoChange = (event, rowData) => {
    const nuevoEstado = event.target.value

    const body = {
      proceso_id: rowData.proceso_id,
      posicion: rowData.posicion || null,
      material: rowData.material || null,
      documento_ventas: rowData.documento_ventas,
      numero_entrega: rowData.numero_entrega || null,
      numero_transporte: rowData.numero_transporte || null,
      estado: nuevoEstado,
      rol_id: myRol.id,
      mensaje: rowData.msg,
      gestion: 0,
    }

    console.log(body, 'body 2')
    handlePostBitacora(body)

    setEventosGestion((prevState) =>
      prevState.map((evento) =>
        evento === rowData ? { ...evento, estado: nuevoEstado } : evento,
      ),
    )
  }

  const handleCheckClick = async (rowData) => {
    setLoadingRow({
      proceso_id: rowData.proceso_id,
      gestion: rowData.gestion,
      reintentos: rowData.reintentos,
      msg: rowData.msg,
    })
    const body = {
      proceso_id: rowData.proceso_id,
      posicion: rowData.posicion || null,
      material: rowData.material || null,
      documento_ventas: rowData.documento_ventas,
      numero_entrega: rowData.numero_entrega || null,
      numero_transporte: rowData.numero_transporte,
      estado: 'GESTIONADO',
      rol_id: myRol.id,
      mensaje: rowData.msg,
      gestion: 0,
    }

    const response = await postBitacora(body)
    if (response) {
      setEventosGestion((prevEventos) =>
        prevEventos.map((evento) =>
          evento.proceso_id === rowData.proceso_id &&
          evento.gestion === rowData.gestion &&
          evento.reintentos === rowData.reintentos && 
          evento.msg === rowData.msg
            ? { ...evento, estado: 'GESTIONADO' }
            : evento
        )
      )
      await postLogTom({
        action: `Gestiona el evento ${rowData.proceso_id}`,
      })
    }
    setLoadingRow(null)
  }

  const onAssignPedidos = async () => {
    await postLogTom({
      action: `Gestiona pedidos seleccionados`,
    })
    
    const selectedRows = Object.keys(rowSelection)
    if (selectedRows.length > 0) {
      const selectedRowData = selectedRows.map(index => {
        const rowData = eventosGestion[parseInt(index, 10)]
        return rowData
      })
      
      setLoadingRows(selectedRowData)
      
      const pedidos = selectedRowData.map((rowData) => ({
        proceso_id: rowData.proceso_id,
        posicion: rowData.posicion || null,
        material: rowData.material || null,
        documento_ventas: rowData.documento_ventas,
        numero_entrega: rowData.numero_entrega || null,
        numero_transporte: rowData.numero_transporte,
        estado: 'GESTIONADO',
        rol_id: myRol.id,
        mensaje: rowData.msg,
        gestion: rowData.gestion || 0,
      }))

      const body = {
        bitacoras: pedidos,
      }

      const response = await postMultipleBitacora(body)
      if (response) {
        setEventosGestion((prevEventos) =>
          prevEventos.map((evento) => {
            const match = selectedRowData.find(
              (rowData) =>
                rowData.proceso_id === evento.proceso_id &&
                rowData.gestion === evento.gestion &&
                rowData.reintentos === evento.reintentos &&
                rowData.msg === evento.msg
            )
            return match ? { ...evento, estado: 'GESTIONADO' } : evento
          })
        )
        setRowSelection({})
      }
      setLoadingRows([])
    } else {
      alert('Debe seleccionar al menos un pedido')
    }
  }

  const onEditingRowSave = async ({ values, exitEditingMode }) => {
    try {
      if (new Date(values.gestion) > new Date()) {
        const body = {
          proceso_id: values.proceso_id,
          posicion: values.posicion || null,
          material: values.material || null,
          documento_ventas: values.documento_ventas,
          numero_entrega: values.numero_entrega || null,
          numero_transporte: values.numero_transporte,
          estado: myRol?.id === 2 ? values.estado : 'GESTIONADO',
          rol_id: myRol.id,
          mensaje: values.msg,
          gestion: new Date(values.gestion).getTime() / 1000,
        }
        console.log(body, 'body 1')
        await handlePostBitacora(body)
        exitEditingMode()
        await postLogTom({
          action: `Edita un evento ${values.proceso_id}`,
        })
      } else {
        alert('La fecha seleccionada no puede ser en el pasado.')
        return
      }
    } catch (error) {
      console.error('Error saving row:', error)
    }
  }

  // Función para cambiar tab
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
    if (newValue === 1 && !gestionDataLoaded && myRol) {
      loadGestionData()
    }
  }

  // Effects
  useEffect(() => {
    getInfo()
    const intervalo = setInterval(getInfo, 5 * 60 * 1000)
    return () => clearInterval(intervalo)
  }, [])

  useEffect(() => {
    handleGetMyRol()
  }, [])

  useEffect(() => {
    if (myRol && !gestionDataLoaded) {
      loadGestionData()
    }
  }, [myRol])

  return {
    // Estados
    deltas,
    eventos,
    alertas,
    myRol,
    isLoadingDeltas,
    isLoadingAlertas,
    isLoadingEventos,
    isLoadingDocumento,
    isLoadingGestion,
    loadingRow,
    loadingRows,
    procesoFiltro,
    mostrarGestionados,
    openAlertDialog,
    mostrarAlertas,
    eventosGestion,
    gestionDataLoaded,
    activeTab,
    rowSelection,
    
    // Setters
    setMostrarGestionados,
    setOpenAlertDialog,
    setMostrarAlertas,
    setRowSelection,
    
    // Funciones
    refreshDashboardData,
    refreshGestionData,
    downloadExcel,
    handleProcesoFiltro,
    handleEstadoChange,
    handleCheckClick,
    onAssignPedidos,
    onEditingRowSave,
    handleTabChange,
  }
} 